import { useEffect, useState } from "react";
import { Table, Button, Select, Tooltip, Pagination, message, Typography } from "antd";
import type { TableColumnsType, PaginationProps } from "antd";
import ManualSamplingModal from "./ManualSamplingModal";
import {
  ResponseAPI,
  FilterCombustion,
  CombustionManualSamling,
  ManualEmissionSampling,
  SamplingEmission,
  RowData,
  DataTable,
  FileDetails,
} from "src/entity/manual-sampling/manual-sampling.entity";
import { calculateReportVocEmission, getManualSamplingCombustions, updateManualSamplingCombust } from "src/services/combustion.service";
import { FileOutlined } from "@ant-design/icons";
import { componentPalette } from "src/theme/component-palette";
import FileDescriptionList from "./FileDescriptionList";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { canEditTable, canViewTable } from "../../PermissionCheck/PermissionCheck";
import { BsPencilSquare } from "react-icons/bs";
import "./ManualSamplingTable.css";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import { parseAndFormatScientificNumber } from "src/utils/process-number";
import { generateYearArray } from "src/utils/array";
import { convertEmissionWord } from "src/entity/common/global.entity";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

const { Text } = Typography;

const ManualFuelVolumeTable = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const currentYear = new Date().getFullYear();
  const profile = profileStore(useShallow((state) => state.profile));
  const [companyId, setCompanyId] = useState<string>("");
  const { permissions } = useNavigationMenu();
  const [data, setData] = useState<CombustionManualSamling[]>();
  const [optionYears, setOptionYears] = useState<number[]>([]);
  const [selectedYear, setSelectedYear] = useState<number>();
  const [loading, setLoading] = useState(false);
  const [showModalStackInfo, setShowModalStackInfo] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [filterCombustion, setFilterCombustion] = useState<FilterCombustion>();
  const [dataTransform, setDataTransform] = useState<DataTable>([]);
  const [dataTable, setDataTable] = useState<DataTable>([]);
  const [initialData, setInitialData] = useState<CombustionManualSamling>({
    year: "",
    companyId: "",
    stackId: "",
    sourceId: "",
    area: "",
    fuelName: "",
    fuelType: "",
    emission: {
      tvoc: false,
      bz: false,
      bd: false,
      vcm: false,
      edc: false,
    },
    manualEmissionSampling: {
      jan: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      feb: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      mar: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      apr: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      may: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      jun: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      jul: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      aug: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      sep: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      oct: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      nov: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
      dec: {
        emission: {
          tvoc: {
            value: 0,
            unit: "",
          },
          bz: {
            value: 0,
            unit: "",
          },
          bd: {
            value: 0,
            unit: "",
          },
          vcm: {
            value: 0,
            unit: "",
          },
          edc: {
            value: 0,
            unit: "",
          },
          operatingHours: {
            value: 0,
            unit: "",
          },
        },
        files: [],
        reportStatus: "",
      },
    },
  });

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    setSelectedYear(years[0] as number);
  };

  const createParamFilter = () => {
    let queryParam = "";
    let offset = 0;
    let limit = pageSize;
    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }
    if (current) {
      let resultCalOffset = calPagination(current);
      if (resultCalOffset) {
        offset = resultCalOffset;
      }
      queryParam += `&offset=${offset}`;
    }
    if (limit) {
      queryParam += `&limit=${limit}`;
    }

    return queryParam;
  };

  const fetchCombustions = async () => {
    try {
      if (companyId) {
        setLoading(true);
        let offset = 0;
        let resultCalOffset = calPagination(current);
        if (resultCalOffset) {
          offset = resultCalOffset;
        }
        const queryParam = createParamFilter();
        let response = await getManualSamplingCombustions(companyId, queryParam);
        let responseData: ResponseAPI = response.data;
        if (responseData.code === 200) {
          setLoading(false);
          let combustions = responseData.data.combustions.map((el, index) => {
            return {
              no: (index + offset + 1).toString(),
              ...el,
            };
          });

          setData([...combustions]);
          setTotal(responseData.data.total);

          const rowData: RowData[] = [];
          combustions.forEach((combust, index) => {
            const dataTf: DataTable = transformData(combust.manualEmissionSampling);
            dataTf.forEach((el, idxtf) => {
              rowData.push({
                index: idxtf,
                _id: combust._id,
                no: (index + offset + 1).toString(),
                stackId: combust.stackId,
                sourceId: combust.sourceId,
                area: combust.area,
                key: el.key,
                parameter: el.parameter,
                unit: el.unit,
                jan: el.jan,
                feb: el.feb,
                mar: el.mar,
                apr: el.apr,
                may: el.may,
                jun: el.jun,
                jul: el.jul,
                aug: el.aug,
                sep: el.sep,
                oct: el.oct,
                nov: el.nov,
                dec: el.dec,
                total: el.total,
              });
            });
          });
          // console.log("Initial DataSOURCE : ", rowData);
          setDataTable(rowData);
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const handleYearChange = (value: number) => {
    setSelectedYear(value);
  };

  const handleSaveCombustion = async (data: CombustionManualSamling) => {
    try {
      let id = data._id;
      if (id && companyId) {
        setLoading(true);
        data.companyId = companyId;
        let response = await updateManualSamplingCombust(companyId, id, data);
        const responseData: ResponseAPI = response.data;
        if (responseData.code === 200) {
          setLoading(false);
          messageApi.open({
            type: "success",
            content: CommonSuccess.SAVED_SUCCESSFULL,
          });
          processCalculateReport(id);
          fetchCombustions();
          setLoading(false);
          setShowModalStackInfo(false);
        } else {
          messageApi.open({
            type: "success",
            content: CommonSuccess.SAVED_SUCCESSFULL,
          });
        }
      }
    } catch (error) {
      setLoading(false);
      messageApi.open({
        type: "success",
        content: CommonSuccess.SAVED_SUCCESSFULL,
      });
    } finally {
      setLoading(false);
    }
  };

  const processCalculateReport = async (id: string) => {
    try {
      setLoading(true);
      await calculateReportVocEmission(id);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModalManCombust = (combustionId: string) => {
    const combustion = data?.find((el) => el._id == combustionId);
    if (combustion) {
      setInitialData(combustion);
      let dataTf: DataTable = transformData(combustion.manualEmissionSampling);
      setDataTransform(dataTf);
      setShowModalStackInfo(true);
    }
  };

  const transformData = (manualEmissionSampling: ManualEmissionSampling): DataTable => {
    const sort: (keyof SamplingEmission)[] = ["tvoc", "bz", "bd", "vcm", "edc", "operatingHours"];
    const resultParam = Object.keys(manualEmissionSampling.jan.emission) as (keyof SamplingEmission)[];
    const sortedResultParam = resultParam.sort((a, b) => sort.indexOf(a) - sort.indexOf(b));
    const parameters: (keyof SamplingEmission)[] = sortedResultParam;
    const months: (keyof ManualEmissionSampling)[] = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

    const dataTable: DataTable = parameters.map((param) => {
      let unit = "";
      let parameterLabel = param.toUpperCase();
      if (param == "operatingHours") {
        parameterLabel = "Operating Hours";
      }

      if (["tvoc", "bz", "bd", "vcm", "edc"].includes(param)) {
        unit = "g/s";
      } else {
        unit = "HR.";
      }
      let rowData: RowData = {
        key: param,
        parameter: parameterLabel,
        unit: unit,
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0,
        total: 0,
      };

      let total = 0;

      months.forEach((month) => {
        const monthlyData = manualEmissionSampling[month];
        const value = monthlyData.emission[param]?.value || 0;
        if (typeof value === "number") {
          rowData[month] = value ?? 0;
        }
        if (value) {
          total += value;
        }
      });

      rowData.total = total ?? 0;

      return rowData;
    });
    dataTable.push({
      key: "reference",
      parameter: "Reference",
      unit: "",
      jan: manualEmissionSampling.jan.fileDetails ?? [],
      feb: manualEmissionSampling.feb.fileDetails ?? [],
      mar: manualEmissionSampling.mar.fileDetails ?? [],
      apr: manualEmissionSampling.apr.fileDetails ?? [],
      may: manualEmissionSampling.may.fileDetails ?? [],
      jun: manualEmissionSampling.jun.fileDetails ?? [],
      jul: manualEmissionSampling.jul.fileDetails ?? [],
      aug: manualEmissionSampling.aug.fileDetails ?? [],
      sep: manualEmissionSampling.sep.fileDetails ?? [],
      oct: manualEmissionSampling.oct.fileDetails ?? [],
      nov: manualEmissionSampling.nov.fileDetails ?? [],
      dec: manualEmissionSampling.dec.fileDetails ?? [],
      total: [],
    });

    return dataTable;
  };

  const checkValue = (value: FileDetails[] | "" | number, record: any) => {
    if (Array.isArray(value)) {
      let color = "gray";
      if (value.length != 0) {
        color = componentPalette.primary;
      }
      return (
        <>
          <Tooltip
            overlayInnerStyle={{ color: "black" }}
            color="white"
            placement="topLeft"
            title={value.length != 0 ? <FileDescriptionList files={value} /> : "No Data"}
            arrow
          >
            <FileOutlined style={{ color: color, fontSize: "14px" }} />
          </Tooltip>
        </>
      );
    } else {
      if (record.key === "operatingHours") {
        return parseAndFormatScientificNumber(`${Number(value)}`, 2) ?? 0;
      } else {
        return parseAndFormatScientificNumber(`${Number(value)}`, 6) ?? 0;
      }
    }
  };

  const subTableColumns: TableColumnsType = [
    {
      title: "No",
      dataIndex: "no",
      width: 40,
      render: (text, record, index) => {
        const obj = {
          children: <Text>{text}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || dataTable[index - 1]._id !== record._id) {
          obj.props.rowSpan = dataTable.filter((item) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "Stack ID",
      dataIndex: "stackId",
      width: 100,
      render: (text, record, index) => {
        const obj = {
          children: <Text>{text}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || dataTable[index - 1]._id !== record._id) {
          obj.props.rowSpan = dataTable.filter((item) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "Source ID",
      dataIndex: "sourceId",
      key: "sourceId",
      width: 100,
      render: (text, record, index) => {
        const obj = {
          children: <Text>{text}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || dataTable[index - 1]._id !== record._id) {
          obj.props.rowSpan = dataTable.filter((item) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
      render: (text, record, index) => {
        const obj = {
          children: <Text>{text}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || dataTable[index - 1]._id !== record._id) {
          obj.props.rowSpan = dataTable.filter((item) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "Emission",
      dataIndex: "parameter",
      render: (text) => <Text>{convertEmissionWord(text)}</Text>,
    },
    { title: "Unit", dataIndex: "unit", key: "unit", render: (text) => <Text>{text}</Text> },
    {
      title: "Jan",
      dataIndex: "jan",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Feb",
      dataIndex: "feb",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Mar",
      dataIndex: "mar",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Apr",
      dataIndex: "apr",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "May",
      dataIndex: "may",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Jun",
      dataIndex: "jun",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Jul",
      dataIndex: "jul",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Aug",
      dataIndex: "aug",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Sep",
      dataIndex: "sep",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Oct",
      dataIndex: "oct",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Nov",
      dataIndex: "nov",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Dec",
      dataIndex: "dec",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },
    {
      title: "Total",
      dataIndex: "total",
      render: (value, record) => {
        return <Text>{checkValue(value, record)}</Text>;
      },
    },

    {
      title: "Action",
      key: "action",
      render: (text, record, index) => {
        const obj = {
          children: (
            <div>
              <Button
                className="border-transparent bg-transparent"
                disabled={!canEditTable(permissions)}
                onClick={() => {
                  handleOpenModalManCombust(record._id);
                }}
              >
                <BsPencilSquare size={18} color={componentPalette.blueGrey} />
              </Button>
            </div>
          ),
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || dataTable[index - 1].no !== record.no) {
          obj.props.rowSpan = dataTable.filter((item) => item.no === record.no).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    },
  ];

  const columns: TableColumnsType = addCenterAlign(subTableColumns);

  const onChangePagination: PaginationProps["onChange"] = (page) => {
    setCurrent(page);
  };

  const intitalData = () => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }
  };

  useEffect(() => {
    intitalData();
    fetchYear();
  }, []);

  useEffect(() => {
    intitalData();
  }, [profile?.activeCompany]);

  useEffect(() => {
    setSelectedYear(currentYear);
    setCurrent(1);
  }, [companyId]);

  useEffect(() => {
    if (selectedYear) {
      const fetchData = async () => {
        await fetchCombustions();
      };

      fetchData();
    }
  }, [selectedYear, current, filterCombustion, companyId]);

  useEffect(() => {
    setCurrent(1);
  }, [selectedYear]);

  return (
    <>
      {contextHolder}
      {showModalStackInfo && companyId && (
        <ManualSamplingModal
          open={showModalStackInfo}
          companyId={companyId}
          year={selectedYear}
          dataTable={dataTransform}
          initialData={initialData}
          loadingSave={loading}
          onCancelManualSam={() => {
            setShowModalStackInfo(false);
            fetchCombustions();
          }}
          onSaveManualSam={(data) => {
            handleSaveCombustion(data);
          }}
        />
      )}
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "10px" }}>
        <div>
          <Select
            value={selectedYear}
            style={{ width: 120 }}
            onChange={handleYearChange}
            options={optionYears.map((year) => ({ label: year, value: year }))}
            loading={loading}
            size="middle"
          />
        </div>
      </div>
      <Table
        className="w-full mt-4"
        style={{ whiteSpace: "nowrap" }}
        rowKey={(record, index) => `${record._id}-${index}`}
        columns={columns}
        dataSource={canViewTable(permissions) ? dataTable : []}
        scroll={{ x: "max-content" }}
        pagination={false}
        loading={loading}
      />

      <Pagination
        size={"small"}
        showSizeChanger={false}
        style={{ display: "flex", justifyContent: "right", padding: "7px" }}
        current={current}
        total={total}
        onChange={onChangePagination}
      />
    </>
  );
};

export default ManualFuelVolumeTable;
